import detectBrowser from 'browser-detect';

export const browser = detectBrowser(navigator.userAgent);

// iPadOS useragent is buggy at the moment
// this is a mobile detection fix until iPadOS useragent string is fixed
export const isIpadOS =
  navigator.platform === 'MacIntel' && navigator.maxTouchPoints > 1;
export const isMobile = browser.mobile || isIpadOS;
export const isChrome = browser.name === 'chrome';
export const isSafari = browser.name === 'safari';
export const safariVersion =
  browser.name === 'safari' ? browser.versionNumber : undefined;
export const isIE = browser.name === 'ie';
export const isApple = browser.os.indexOf('OS X') !== -1;
export const isIOS = isApple && isMobile;

// Device type to distinguish between mobile/tablet/desktop
const getDeviceType = () => {
  const ua = navigator.userAgent;
  if (
    /(tablet(?!.*PC)|ipad|playbook|silk)|(android(?!.*mobi))/i.test(
      ua,
    )
  ) {
    return 'tablet';
  }
  if (
    /Mobile|iP(hone|od)|Android|BlackBerry|IEMobile|Kindle|Silk-Accelerated|(hpw|web)OS|Opera M(obi|ini)/.test(
      ua,
    )
  ) {
    return 'mobile';
  }
  return 'desktop';
};
export const deviceType = getDeviceType();
